export const ROUTE_DASHBOARD = 'ROUTE_DASHBOARD'
export const REPORT_REGISTERS = 'REPORT_REGISTERS'
export const REPORT_ACCESS = 'REPORT_ACCESS'
export const REPORT_DOCUMENTS = 'REPORT_DOCUMENTS'
export const REPORT_AFFILIATES = 'REPORT_AFFILIATES'
